import { actionCreator } from '@/utils/redux';

import { Bank, NAMESPACE } from './types';

const creator = actionCreator(NAMESPACE);

export interface StoreInitActionPayload {
  banks: Bank[];
}

// sagas
export const init = creator.asyncAction<void>('INIT');

// reducers
export const storeInitialized = creator.syncActionWithPayload<StoreInitActionPayload>('STORE_INIT');
export const storeLogout = creator.syncAction('STORE_LOGOUT');

// notifications
export const notifyInitializationFinished = creator.syncAction('INIT_FINISHED');

export default {
  init,
  storeInitialized,
  storeLogout,
  notifyInitializationFinished,
};
